import React from 'react';
import { styled } from "../../stitches.config"
import { bodyStrong } from "../commonStyles/Fonts";
import PhotoOnLeft from "./PhotoOnLeft";

import { SimilarArticlesType } from "../../stores/ArticleStore"
import { withThemeContext } from './StitchesThemeProvider';

type SeeAlsoVideosProps = {
    articles: SimilarArticlesType[];
}

const SeeAlsoVideos: React.FC<SeeAlsoVideosProps> = ({
    articles,
    ...props
}) => {
    return (
        <StyledSeeAlsoVideos>
            <Header>
                <p className={bodyStrong()}>Zobacz także</p>
                <BlackLine></BlackLine>
            </Header>
            <Wrapper>
                {articles.map((article, i) =>
                    <PhotoOnLeft
                        key={"similar_articles__" + i}
                        article={article}
                        boxSize="xxs" />
                )}
            </Wrapper>
            <BlackLine></BlackLine>
        </StyledSeeAlsoVideos>
    );
};

const StyledSeeAlsoVideos = styled('div', {
    margin: "40px 44px 40px 16px",
    "@bp4": {
        margin: "20px 0",
    }
})

const Wrapper = styled('div', {
    padding: "40px 0 16px 0",
    "& a": {
        marginBottom: "24px",
    }
})

const Header = styled('div', {
    display: "flex",
    alignItems: "center",
    "& p": {
        flexShrink: 0,
        margin: "0 16px 0 0",
        color: '$grayscale100',
    }
})

const BlackLine = styled('div', {
    borderTop: "2px solid $grayscale100",
    width: "100%",
})

export default withThemeContext(SeeAlsoVideos)